"use strict";
// tslint:disable
// eslint-disable
/**
 * HEM Workbench API Specification
 * Health Economics Workbench API Specification
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetadataApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 * no description
 */
class MetadataApi extends runtime.BaseAPI {
    /**
     * Allow to delete metadata option even it is not used in any model
     */
    deleteMetadataOptionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.type === null || requestParameters.type === undefined)) {
                throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling deleteMetadataOption.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.value === null || requestParameters.value === undefined)) {
                throw new runtime.RequiredError('value', 'Required parameter requestParameters.value was null or undefined when calling deleteMetadataOption.');
            }
            const queryParameters = {};
            if (requestParameters.value !== undefined) {
                queryParameters['value'] = requestParameters.value;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/metadata/option/{type}`.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Allow to delete metadata option even it is not used in any model
     */
    deleteMetadataOption(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteMetadataOptionRaw(requestParameters);
        });
    }
    /**
     * Get collection of metadata for povided modelUuid
     */
    getMetadataRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling getMetadata.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/vestlead/{userId}`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get collection of metadata for povided modelUuid
     */
    getMetadata(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMetadataRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get File tag usage count
     */
    getMetadataTypeCountRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.metadataType === null || requestParameters.metadataType === undefined)) {
                throw new runtime.RequiredError('metadataType', 'Required parameter requestParameters.metadataType was null or undefined when calling getMetadataTypeCount.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/model/metadata/count/{metadataType}`.replace(`{${"metadataType"}}`, encodeURIComponent(String(requestParameters.metadataType))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.MetadataCountDTOFromJSON));
        });
    }
    /**
     * Get File tag usage count
     */
    getMetadataTypeCount(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMetadataTypeCountRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get allowed options for model metadata
     */
    getModelMetadataOptionsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.retired !== undefined) {
                queryParameters['retired'] = requestParameters.retired;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/model/metadata/options`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ModelMetadataOptionsDTOFromJSON(jsonValue));
        });
    }
    /**
     * Get allowed options for model metadata
     */
    getModelMetadataOptions(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getModelMetadataOptionsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Return list of models UUID if a value for the option is used by a model
     */
    getUsageOfOptionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.type === null || requestParameters.type === undefined)) {
                throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling getUsageOfOption.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/metadata/option/{type}/usage`.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Return list of models UUID if a value for the option is used by a model
     */
    getUsageOfOption(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUsageOfOptionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Allow to add a new metadata option for Therepeutic Area and Study Numbers
     */
    saveMetadataOptionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelMetadataOptionDTO === null || requestParameters.modelMetadataOptionDTO === undefined)) {
                throw new runtime.RequiredError('modelMetadataOptionDTO', 'Required parameter requestParameters.modelMetadataOptionDTO was null or undefined when calling saveMetadataOption.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/metadata/option`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ModelMetadataOptionDTOToJSON(requestParameters.modelMetadataOptionDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ModelMetadataOptionDTOFromJSON(jsonValue));
        });
    }
    /**
     * Allow to add a new metadata option for Therepeutic Area and Study Numbers
     */
    saveMetadataOption(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveMetadataOptionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Allow to update metadata option
     */
    updateMetadataOptionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.type === null || requestParameters.type === undefined)) {
                throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling updateMetadataOption.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.value === null || requestParameters.value === undefined)) {
                throw new runtime.RequiredError('value', 'Required parameter requestParameters.value was null or undefined when calling updateMetadataOption.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.modelMetadataOptionDTO === null || requestParameters.modelMetadataOptionDTO === undefined)) {
                throw new runtime.RequiredError('modelMetadataOptionDTO', 'Required parameter requestParameters.modelMetadataOptionDTO was null or undefined when calling updateMetadataOption.');
            }
            const queryParameters = {};
            if (requestParameters.value !== undefined) {
                queryParameters['value'] = requestParameters.value;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/metadata/option/{type}`.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ModelMetadataOptionDTOToJSON(requestParameters.modelMetadataOptionDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Allow to update metadata option
     */
    updateMetadataOption(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateMetadataOptionRaw(requestParameters);
        });
    }
}
exports.MetadataApi = MetadataApi;
